<app-select-user
    [form]="form"
    [serviceId]="serviceId"
    [employment]="employment"
></app-select-user>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        (primaryClickEvent)="submit()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
